import type { CitationsProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

export const Citations = (props: CitationsProps) => {
  return <LazyComponent<CitationsProps> name="Citations" {...props} />;
};
